const actions = {
  GET_TABLES_REQUEST: "GET_TABLES_REQUEST",
  GET_TABLES_SUCCESS: "GET_TABLES_SUCCESS",

  TOGGAL_BILL_DETAILS_REQUEST: "TOGGAL_BILL_DETAILS_REQUEST",
  TOGGAL_BILL_DETAILS_SUCCESS: "TOGGAL_BILL_DETAILS_SUCCESS",

  getDailyTableStatistics: (startDate, endDate, restaurant) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_TABLES_REQUEST,
        startDate,
        endDate,
        restaurant,
      });
    };
  },

  getBillDetailsModal: (billId) => ({
    type: actions.TOGGAL_BILL_DETAILS_REQUEST,
    billId: billId,
  }),
};

export default actions;
